var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _vm.deepGet(_vm.form, 'config.content_page.banner_image') ? _c('img', {
    staticClass: "banner-image w-100",
    attrs: {
      "src": _vm.deepGet(_vm.form, 'config.content_page.banner_image')
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_vm.deepGet(_vm.form, 'config.content_page.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.form, 'config.content_page.form_title')) + " ")]) : _vm._e(), _vm.deepGet(_vm.form, 'config.content_page.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.form, 'config.content_page.form_desc')) + " ")]) : _vm._e(), _vm.deepGet(_vm.form, 'config.content_page.content') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.deepGet(_vm.form, 'config.content_page.content'))
    }
  }) : _vm._e(), _c('DynamicForm', {
    ref: "dynamicForm",
    staticClass: "my-4 mx-2",
    attrs: {
      "input-subjects": _vm.dynamicFormFields
    },
    model: {
      value: _vm.inputForm,
      callback: function callback($$v) {
        _vm.inputForm = $$v;
      },
      expression: "inputForm"
    }
  }), _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.form, 'config.content_page.button_text', '送出')) + " ")]), _vm.deepGet(_vm.form, 'terms') ? _c('div', {
    staticClass: "mt-3 p-3",
    domProps: {
      "innerHTML": _vm._s(_vm.deepGet(_vm.form, 'terms'))
    }
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }